import { StartRegistrationDTO } from '../../model/data/StartRegistrationDTO';

export namespace RegistrationActions {
  const prefix: string = '[Registration]';

  export class StartRegistration {
    static readonly type = `${prefix} Start registration`;

    constructor(public registrationData: StartRegistrationDTO) {}
  }
}
